<div class="panel-group be-collapse-box" id="accordion" role="tablist" aria-multiselectable="true">
  <div class="panel panel-default">
    <div class="panel-heading" role="tab" id="headingOne">
      <div class="panel-title">
        <a role="button" data-toggle="collapse" data-parent="#premarketing" href="#premarketing" aria-expanded="true" aria-controls="premarketing">
          <h2 class="mainhead"><span _ngcontent-hkv-c8="" class="text">Premarketing</span></h2>
        </a>
      </div>
    </div>
    <div id="premarketing" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
      <div class="panel-body">
        <div class="row">
          <ng-container *ngFor="let singel of singelPremarketingList">
            <div class="col-xs-12" *ngFor="let item of singel.PremaretingStatusList">
              <div class="border-div margin-bottom-15">
                <div class="pro-status-box d-flex align-item-center">
                  <label class="custom-checkbox mr-auto" for="checkbox_{{item.Id}}">
                    <input [disabled]="!isEditable ? true: null" [(ngModel)]="item.IsChecked" id="checkbox_{{item.Id}}" type="checkbox" ng-reflect-model="true" class="ng-pristine ng-valid ng-touched" (ngModelChange)="saveStatus(item)">
                    {{item.TaskName}}
                    <i></i>
                  </label>
                  <span [ngClass]='item.IsChecked ? "status-text completed" : "status-text Pending"'>{{item.IsChecked ? "Completed" : "Pending"}}</span>
                </div>
                <p class="info-text">B+E's brokers, analysts, marketing, and PR teams begin the pre-marketing process.</p>
              </div>
            </div>
          </ng-container>
          <div class="clearfix"></div>
          <div class="d-flex pro-status-box-wrap">
            <div *ngFor="let data of premarketingList equal-height-box" class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
              <div class="border-div">
                <div class="pro-status-box d-flex align-item-center">
                  <label class="custom-checkbox mr-auto" for="checkbox_{{data.AssociatedStatusId}}">
                    <input #parent (change)="updateChild(parent.checked,data)" [disabled]="!isEditable ? true: null" class="ng-pristine ng-valid ng-touched" type="checkbox" [checked]="checkFullCompleted(data)" id="checkbox_{{data.AssociatedStatusId}}"> {{data.AssociatedStatusName}}
                    <i></i>
                  </label>
                  <span [ngClass]='checkFullCompleted(data) ? "status-text completed" : "status-text Pending"'>{{checkFullCompleted(data) ? "Completed" : "Pending"}}</span>
                </div>
                <p class="info-text">
                  {{data.AssociatedStatusId == 6200 ? "B+E's team prepares offering memorandum for external marketing use." : (data.AssociatedStatusId == 6201 ? "B+E plans a strategic and targeted approach to outbound marketing campaigns in order to target the most likely buyer and create a competitive market." : (data.AssociatedStatusId == 6202 ? "Property listing page is live! Buyers can now access the property listing via the B+E website and other third-party platforms. Additionally, the PR, email, and call campaigns begin." : ""))}}
                </p>
                <div class="pro-status-box  pro-status-sub-task">
                  <div *ngFor="let item of data.PremaretingStatusList" class="d-flex align-item-center">
                    <label class="custom-checkbox mr-auto" for="checkbox_{{item.Id
                                    }}">
                      <input [disabled]="!isEditable ? true: null" class="ng-pristine ng-valid ng-touched" type="checkbox" [(ngModel)]="item.IsChecked" id="checkbox_{{item.Id}}" (ngModelChange)="saveStatus(item)"> {{item.TaskName}}
                      <i></i>
                    </label>
                    <span [ngClass]='item.IsChecked ? "status-text completed" : "status-text Pending"'>{{item.IsChecked ? "Completed" : "Pending"}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
